import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateTestimonialSaga } from "src/store/testimonials/saga";
import { TestimonialDetailDto } from "src/store/testimonials/type";
import * as Yup from "yup";

const TestimonialEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: TestimonialDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Testimonial.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          NameSurname: data.NameSurname,
          Message: data.Message,
          AvatarFile: data.Avatar,
          AvatarFileField: [data.Avatar ?? ""],
          Translates: data.Translates,
        }}
        validationSchema={Yup.object().shape({
          // NameSurname: Yup.string().required(
          //   t("Validation.Required").toString()
          // ),
          // Message: Yup.number().required(t("Validation.Required").toString()),
          // Translates: Yup.array(
          //   Yup.object({
          //     Message: Yup.string().required(
          //       t("Validation.Required").toString()
          //     ),
          //     NameSurname: Yup.string().required(
          //       t("Validation.Required").toString()
          //     ),
          //   })
          // ),
        })}
        multilanguageinputs={[
          {
            field: "NameSurname",
            label: t("Testimonial.NameSurname").toString(),
          },
          {
            field: "Message",
            label: t("Testimonial.Message").toString(),
            type: "textarea",
          },
        ]}
        inputs={[
          {
            field: "AvatarFile",
            fileField: "ImageFileField",
            label: t("Testimonial.Avatar").toString(),
            type: "file",
          },
        ]}
        onSubmit={(values) => {
          dispatch(
            updateTestimonialSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
      />
    </React.Fragment>
  );
};
export default TestimonialEditForm;
